export default {
    SET_SOCKET(state,socket){
      state.socket = socket
    }
};
